import { Router } from '@angular/router';
import { EReducers, IReducers } from './../reducers/index';
import { Store } from '@ngrx/store';
import { IUserSessionData, UserState } from 'app/store/models/user.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { getUserSession } from '../actions/user.action';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  ready: BehaviorSubject<IUserSessionData>;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private router: Router,
  ) {
  }

  onReady(): Observable<IUserSessionData> {
    return this.ready.asObservable();
  }

  loadUserSession() {
    this.ready = new BehaviorSubject<IUserSessionData>(undefined);
    this.store
      .select(EReducers.USER)
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((x, y) => {
          if (x.sessionData === undefined || y.sessionData === undefined) {
            return false;
          }

          return (
            JSON.stringify(x.sessionData) === JSON.stringify(y.sessionData)
          );
        }),
      )
      .subscribe((state: UserState) => {
        if (!state.loggedIn && window.location.pathname !== '/login') {
          this.router.navigate(['/']);
          return;
        }

        if (state.sessionData === undefined) {
          this.store.dispatch(getUserSession());
          return;
        } else {
          this.ready.next(state.sessionData);
        }
      });
  }

  destroySession() {
    this.destroy$.next(false);
  }
}
